export default __webpack_public_path__ + "static/funlearning-banner-d1e99167b0b027d6ef7c123380eb12d8.png";